import get from 'lodash.get';

const getButtonPresetPreviewTemplate = (state) =>
  get(state, 'ws.template.meta.customization.buttonPresetPreviewTemplate', '');

export default getButtonPresetPreviewTemplate;
